import React from "react";
import {ReactComponent as PaySvg} from "../../assets/images/pay.svg";
import {ReactComponent as TradingViewLogo} from "../../assets/images/tradingview-logo-vector.svg";

const SecureCheckout = () => {

    return (
        <>
            <section className="section-secure-checkout">
                <div className="generic-container">
                    <img src={require('assets/images/stripe-secure.png')} alt="secure checkout"
                         className="w-full object-cover"/>
                    <PaySvg/>
                </div>
            </section>
            <section className="section-powered-by">
                <div className="generic-container gap-5">
                    <div className="flex justify-center items-center">
                        <p>Powered by</p>
                    </div>
                    <div className="flex justify-center items-center">
                        <TradingViewLogo/>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SecureCheckout;